<template>
  <div class="body-wrapper">
    <div>
      <nav-bar />

      <b-container fluid class="db-main">
        <b-row>
          <b-col md="12" lg="9" class="db-main-left">
            <!-- first row -->
            <b-row>
              <b-col md="12">
                <h1 class="mt-4 mb-3n font-weight-bold">
<!--                  {{ dashboardData.greeting }}-->
                  {{ $store.state.authenticatedUserData.user.full_name }},
                  <span>Here is what's happening</span><br /><br />
                </h1>
              </b-col>
            </b-row>

            <!-- second row -->
            <b-row>
              <b-col md="12">
                <h3 class="mb-2">
                  {{ dashboardData.business_details.company_name }}
                </h3>
                <b-row class="worker-info">
                  <b-col
                    sm="6"
                    md="6"
                    lg="6"
                    xl="3"
                    class="grid-margin stretch-card"
                  >
                    <b-card>
                      <b-card-sub-title class="mb-2">{{
                        dashboardData.team_member
                      }}</b-card-sub-title>
                      <template> </template>
                      <b-card-text>Team Members</b-card-text>
                    </b-card>
                  </b-col>

                  <b-col
                    sm="6"
                    md="6"
                    lg="6"
                    xl="3"
                    class="grid-margin stretch-card"
                  >
                    <b-card sub-title="0">
                      <b-card-text>Active Work Orders</b-card-text>
                    </b-card>
                  </b-col>

                  <b-col
                    sm="6"
                    md="6"
                    lg="6"
                    xl="3"
                    class="grid-margin stretch-card"
                  >
                    <b-card sub-title="0/82">
                      <b-card-text>Active Quotes</b-card-text>
                    </b-card>
                  </b-col>
                  <b-col
                    sm="6"
                    md="6"
                    lg="6"
                    xl="3"
                    class="grid-margin stretch-card"
                  >
                    <b-card sub-title="$0">
                      <b-card-text>Awarded Tenders</b-card-text>
                    </b-card>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <!-- third row -->
            <h4 class="my-4">Tender Management</h4>
            <b-row class="db-box">
              <b-col sm="12" md="6" lg="6" class="card-margin">
                <b-card header-tag="header">
                  <template #header>
                    <h4 class="card-title">
                      <span class="db-count">{{
                        dashboardData.counts.tender_submitted_quotes
                      }}</span>
                      Active Tenders
                    </h4>
                    <router-link
                      class="db-view-btn"
                      :to="{
                        name: 'contractor-quote',
                        query: {
                          filterStatus: 'pending-approval',
                        },
                      }"
                      >View All</router-link
                    >
                  </template>

                  <b-list-group class="mb-3">
                    <b-list-group-item
                      v-for="(
                        quote, index
                      ) in dashboardData.quotes.tender_submitted_quotes.slice(
                        0,
                        5
                      )"
                      :key="index"
                      :to="{
                        name: 'contractor-quote-view',
                        params: { id: quote.id },
                        query: {
                          manager_id: filterManager,
                        },
                      }"
                    >
                      <div class="db-content">
                        {{ quote.organization_id }}

                        <div class="db-content-details">
                          <!-- <span class="db-num">3</span> -->
                          <span class="db-arrow pl-2"
                            ><i
                              class="fa fa-chevron-right"
                              aria-hidden="true"
                            ></i
                          ></span>
                        </div>
                      </div>
                    </b-list-group-item>
                    <b-list-group-item
                      v-if="
                        dashboardData.quotes.tender_submitted_quotes.length < 1
                      "
                      >No Quotes Available</b-list-group-item
                    >
                  </b-list-group>
                </b-card>
              </b-col>

              <b-col sm="12" md="6" lg="6" class="card-margin">
                <b-card header-tag="header">
                  <template #header>
                    <h4 class="card-title">
                      <span class="db-count">{{
                        dashboardData.counts.active_quotes
                      }}</span>
                      Active Quotes
                    </h4>
                    <router-link
                      class="db-view-btn"
                      :to="{
                        name: 'contractor-quote',
                        query: {
                          filterStatus: 'pending-approval',
                        },
                      }"
                      >View All</router-link
                    >
                  </template>

                  <b-list-group class="mb-3">
                    <b-list-group-item
                      v-for="(
                        quote, index
                      ) in dashboardData.quotes.active_quotes.slice(0, 5)"
                      :key="index"
                      :to="{
                        name: 'contractor-quote-view',
                        params: { id: quote.id },
                        query: {
                          manager_id: filterManager,
                        },
                      }"
                    >
                      <div class="db-content">
                        {{ quote.organization_id }}

                        <div class="db-content-details">
                          <!-- <span class="db-num">3</span> -->
                          <span class="db-arrow pl-2"
                            ><i
                              class="fa fa-chevron-right"
                              aria-hidden="true"
                            ></i
                          ></span>
                        </div>
                      </div>
                    </b-list-group-item>
                    <b-list-group-item
                      v-if="dashboardData.quotes.active_quotes.length < 1"
                      >No Quotes Available</b-list-group-item
                    >
                  </b-list-group>
                </b-card>
              </b-col>

              <b-col sm="12" md="6" lg="6" class="card-margin">
                <b-card header-tag="header">
                  <template #header>
                    <h4 class="card-title">
                      <span class="db-count">{{
                        dashboardData.counts.pending_approval_quotes
                      }}</span>
                      Pending Approval
                    </h4>
                    <router-link
                      class="db-view-btn"
                      :to="{
                        name: 'contractor-quote',
                        query: {
                          filterStatus: 'pending-approval',
                        },
                      }"
                      >View All</router-link
                    >
                  </template>
                  <b-list-group class="mb-3">
                    <b-list-group-item
                      v-for="(
                        quote, index
                      ) in dashboardData.quotes.pending_approval_quotes.slice(
                        0,
                        5
                      )"
                      :key="index"
                      :to="{
                        name: 'contractor-quote-view',
                        params: { id: quote.id },
                        query: {
                          manager_id: filterManager,
                        },
                      }"
                    >
                      <div class="db-content">
                        {{ quote.organization_id }}

                        <div class="db-content-details">
                          <!-- <span class="db-num">3</span> -->
                          <span class="db-arrow pl-2"
                            ><i
                              class="fa fa-chevron-right"
                              aria-hidden="true"
                            ></i
                          ></span>
                        </div>
                      </div>
                    </b-list-group-item>
                    <b-list-group-item
                      v-if="
                        dashboardData.quotes.pending_approval_quotes.length < 1
                      "
                      >No Quotes Available</b-list-group-item
                    >
                  </b-list-group>
                </b-card>
              </b-col>

              <b-col sm="12" md="6" lg="6" class="card-margin verify-box">
                <b-card>
                  <div class="verify-icon">
                    <!-- <img
                      v-if="dashboardData.business_details.compliant"
                      :src="'/strata/resources/assets/verify.png'"
                      width="35px"
                      class="mb-2"
                      alt=""
                    />

                    <SvgIcons
                      v-else
                      icon="icon-error"
                      width="45"
                      height="55"
                      svgClass="mb-1 mr-4 pull-right"
                    /> -->

                  <div class="text-center" v-if="dashboardData.status">
                    <i class="fas fa-user-check fa-3x mb-3 verified"></i>
                    <h6>Verified by Strata Connex</h6>
                    <p>100% Compliant</p>
                    <i class="fas fa-exclamation-triangle fa-3x mb-3 unverified"></i>
                  </div>

                   <div class="text-center" v-else>
                    <i class="fas fa-exclamation-triangle fa-3x mb-3 unverified"></i>
                    <h6>Not Verified by Strata Connex</h6>
                  </div>
                    <!-- <i
                      v-if="dashboardData.business_details.compliant"
                      class="fas fa-user-check fa-3x mb-3 verified"
                    >
                    </i>

                    <i v-else class="fas fa-exclamation-triangle fa-3x mb-3 unverified"> -->
                    <!-- </i> -->


                  </div>
                  <router-link
                    class="db-view-btn outline"
                    :to="{
                      name: 'contractor-compliance',
                    }"
                    >View compliance</router-link
                  >
                </b-card>
              </b-col>
            </b-row>

            <!-- last row footer -->
            <b-row>
              <b-col md="12" class="d-none d-lg-block my-3">
                <footer-component></footer-component>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="12" lg="3" class="notification-bar">
            <div>
              <h4 class="my-4"> Notifications</h4>
               <ul class="recent-act" v-if="dashboardData.notifications.length > 0">
              <li
                class="activity"
                v-for="(notification, idx) in dashboardData.notifications"
                :key="'noti' + idx"
              >
                <span class="color" v-if="notification.read_at" style="background: #c9c9c9"></span>
                 <span class="color" v-else ></span>

                <div class="notification">
                  <p class="info">
                    <router-link
                      :style="notification.read_at? 'text-decoration:none;color: #3a3b45' : 'text-decoration:none'"
                      exact
                      v-on:click.native="
                        markNotificationAsRead(notification)
                      "
                      :to="{
                        name: setRouteName(notification.data.type),
                        params: {
                          id: notification.data.action_id,
                        },
                      }"
                    >
                      {{ notification.data.text }}
                    </router-link>
                    <!-- <span class="quote"><a href="#!">IN-BEN002.</a></span> -->
                  </p>
                  <p class="time">
                    {{ momentDateFromNow(notification.created_at) }}
                  </p>
                </div>
              </li>
            </ul>
              <p v-else>no notification found.</p>
              <b-button
                v-if="dashboardData.notifications.length > 0"
                variant="outline-primary"
                class="mt-4 mx-auto"
                :to="{ name: 'contractor-notifications' }"
                style="display: block; width: 50%"
                >View All</b-button
              >
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12" class="d-block d-lg-none mt-2">
            <footer-component></footer-component>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import NavBar from "./includes/NavBar.vue";
import FooterComponent from "../includes/FooterComponent.vue";
import FirebasePushNotificationMixin from "@mixins/firebasePushNotificationMixin.js";
import NotificationRouteMixin from "@mixins/notificationRouteMixin.js";
import SvgIcons from "@frontend/pages/includes/SvgIconsComponent.vue";
import moment from "moment";

export default {
  components: {
    NavBar,
    SvgIcons,
    FooterComponent,
  },
  mixins: [FirebasePushNotificationMixin, NotificationRouteMixin],
  data() {
    return {
      dashboardData: {
        business_details: {},
        notifications: [],
        counts: {},
        quotes: {
          active_quotes: [],
          open_quotes: [],
          pending_approval_quotes: [],
        },
        status: false
      },
    };
  },
  mounted() {
    this.refreshDashboard();
    this.initializeFirebasePushNotificationService();
  },
  methods: {
    refreshDashboard() {
      axios.post("api/contractor/dashboard").then((response) => {
        this.dashboardData = response.data;
        let Status= response.data.business_details.is_verified;
         for (var i = 0; i < response.data.licenses.length; i++) {
             if (response.data.licenses[i].licence_status != "verified") {
                 Status = false;
                 break;
            } else if (response.data.licenses[i].licence_status == "verified") {
                 Status = true;
             }
        }

            if(Status!=false){
             for (var i = 0; i < response.data.insurances.length; i++) {
                 if (response.data.insurances[i].insurance_status != "verified") {
                     Status = false;
                    break;
                } else if (response.data.insurances[i].insurance_status == "verified") {
                    Status = true;
                     }
                 }
            }
            this.dashboardData.status= Status;
      });
    },
    handleNotificationClick(notification) {
      if (notification.data.type == "invited_to_quote") {
        this.$router.push({
          name: "contractor-quote-view",
          params: { id: notification.data.action_id },
        });
      }
    },
    markNotificationAsRead(notification) {
      if (notification.read_at) return;
      axios.post("api/contractor/markNotificationAsRead", {
        uuid : notification.id
      }).then((response) => {
      });
    },
    // setRouteName(notification_type){


    // },
    momentDateFromNow(date) {
      return moment(date).fromNow();
    },
  },
};
</script>

<style scoped>
.body-wrapper {
  background-color: #f7f7fc;
}
h1 {
  font-size: 24px;
  color: #000;
}
h4 {
  font-size: 17px;
  color: #000;
  font-weight: 600;
}

.verify-box .card-body {
  max-height: 290px;
}
</style>
